import styled, { css } from 'styled-components';

import hero_bg from '../../assets/img/background.png';

export const Container = styled.div`
  .no-results {
    min-height: 60vh;
  }
`;

export const SearchContainer = styled.div`
  display: flex;

  flex-direction: column;
  align-items: center;
  justify-content: flex-end;

  position: relative;
  animation: rendering 1s;
  background-color: #f2f4f7;

  min-height: 420px;

  padding: 0 10px;

  /*background:  linear-gradient(
      rgba(255, 255, 255, 0.1),
      rgba(255, 255, 255, 0.25)
    ),  url(${hero_bg})
    no-repeat center;
  background-size: cover;*/

  background: url(${hero_bg});
  background-size: cover;
  background-position: center;

  .content {
    margin: 0 auto;
  }

  .filters {
    position: relative;

    margin-top: 0;
  }
`;

export const FilterButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60px;
  font-family: 'Montserrat';
  font-size: 20px;
  color: #131e23;
  background-color: #fff;
  border-radius: 40px;
  padding: 20px;
  border: 0;
  outline: 0;
  // box-shadow: 0px 0px 6px 0px lightgrey;

  > img {
    margin-right: 20px;
  }
`;

export const ContainerInput = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  gap: 5px;
  flex-wrap: wrap;

  font-size: 20px;

  width: 100%;
  max-width: 700px;
  margin: 0 auto;
  margin-top: auto;

  .input {
    img {
      width: 40px;
    }

    font-size: 20px;
    border-radius: 2.5rem;
    height: 90px;
    box-shadow: none;
  }

  .filters__button {
    max-width: 420px;
  }
`;

export const ButtonShowFilters = styled.div`
  font-family: 'Montserrat';
  font-weight: 600;
  font-size: 20px;
  color: #131e23;
  padding: 0 14px;
  width: fit-content;

  border-radius: 2.5rem;
  background-color: #fff;

  display: flex;
  align-items: center;
  justify-content: center;

  height: 80px;
  margin-left: 20px;
  cursor: pointer;

  img {
    width: 40px;
    margin-right: 10px;
  }

  @media (max-width: 810px) {
    width: 100%;
    text-align: center;
    margin-left: 0px;
    margin-bottom: 5rem;
  }
`;

export const Menu = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  > div:nth-of-type(1) {
    div {
      background-color: var(--purple84);
    }
  }

  > div:nth-of-type(2) {
    div {
      background-color: var(--green2c);
    }
  }

  > div:nth-of-type(3) {
    div {
      background-color: #d06454;
    }
  }

  > div:nth-of-type(4) {
    div {
      background-color: #ffe08c;
    }
  }

  @media (max-width: 700px) {
    margin-bottom: -20px;
    flex-direction: column;
    flex-wrap: wrap;
    margin-top: -60px;
  }
`;

export const MenuItem = styled.div`
  cursor: pointer;
  margin: 10px 0px;
  span {
    font-family: 'Montserrat';
    font-size: 1.6rem;
    color: var(--green24);
    margin: 20px;
  }
  div {
    width: 80px;
    height: 2px;
    margin: 10px auto 0px auto;
  }

  box-shadow: 0 0 0 rgba(0, 0, 0, 0.16);

  ${(props) =>
    props.code === props.chosenMenu &&
    css`
      transform: scale(1.1);
      box-shadow: 0 0px 6px rgba(0, 0, 0, 0.16);
      padding: 10px 0px;
      border-radius: var(--border20);
      transition: all 0.5s;
      margin: 0px 10px;
    `}
`;
